<template>
  <figure :style="cssVars" :class="{ 'is-no-border-radius': isNoBorderRadius }">
    <picture>
      <source v-for="(source, idx) in images.sources" :key="idx" :type="source.type" :media="source.media" :srcset="source.srcset">
      <img
        ref="image"
        :src="images.image"
        :loading="!noLazy ? 'lazy' : 'eager'"
        :class="{ 'is-no-border-radius': isNoBorderRadius }"
        :alt="alt"
        decoding="async"
        @load="onLoad"
      >
    </picture>
    <div v-if="!isLoaded && !noLazy" class="api-image-placeholder no-js-hide">
      <slot name="placeholder">
        <b-skeleton />
      </slot>
    </div>
  </figure>
</template>

<script>
import { contentFindOption, contentFindContent } from '../../../plugins/content'
export default {
  props: {
    aspectRatio: {
      type: String,
      default: null
    },
    aspectRatioMobile: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    sizeImage: {
      type: String,
      default: 'w1000'
    },
    isNoBorderRadius: {
      type: Boolean,
      defalt: false
    },
    noLazy: {
      type: Boolean
    }
  },
  data () {
    return {
      isLoaded: false
    }
  },
  computed: {
    images () {
      const main = contentFindContent(this.value?.content, 'main')
      const mobile = contentFindContent(this.value?.content, 'mobile') || null
      const sources = []
      const mainImageSize = main?.fileData?.sizes?.[this.sizeImage]

      let image = null
      if (main?.fileData?.isSvg) {
        image = main.fileData.isSvg.url || ''
      } else if (main?.fileData?.isImage && mainImageSize) {
        image = mainImageSize
        // Main WebP source
        const webpMain = main?.fileData?.sizes?.[this.sizeImage + '-webp'] || null
        if (webpMain) {
          sources.push({ type: 'image/webp', media: '(min-width: 768px)', srcset: webpMain })
        }
      }

      if (mobile?.fileData?.isSvg?.url) {
        sources.push({ type: 'image/svg+xml', media: '(max-width: 768px)', srcset: mobile.fileData.isSvg.url })
      } else if (mobile?.fileData?.isImage && mobile?.fileData?.sizes?.[this.sizeImage]) {
        const mobileWebp = mobile.fileData?.sizes[this.sizeImage + '-webp'] || null
        const mobileStandard = mobile?.fileData?.sizes[this.sizeImage]
        if (mobileStandard) {
          sources.push(
            { type: null, media: '(max-width: 768px)', srcset: mobileStandard }
          )
        }

        if (mobileWebp) {
          sources.push(
            { type: 'image/webp', media: '(max-width: 768px)', srcset: mobileWebp }
          )
        }
      }
      return { sources, image }
    },
    alt () {
      return contentFindOption(this.value?.options, 'alt')?.value
    },
    cssVars () {
      return {
        '--aspect-ratio': this.aspectRatio,
        '--aspect-ratio-mobile': this.aspectRatioMobile
      }
    }
  },
  mounted () {
    // obrazek mógł się załadować (np. z cache) zanim listener @load się podpiął
    const img = this.$refs.image
    if (img && img.complete && img.naturalWidth > 0) {
      this.onLoad()
    }
  },
  methods: {
    onLoad () {
      this.isLoaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
figure {
  position: relative;
  max-height: 100%;
  // width: 100%;
  // height: 100%;
  // background-color: $spati-blue-light;
  aspect-ratio: var(--aspect-ratio) !important;
  overflow: hidden;
  border-radius: 20px;
  @include mobile {
    aspect-ratio: var(--aspect-ratio-mobile) !important;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: middle;
    border-radius: 20px;
  }
}

/* ta sama logika placeholdera co w AppImage — skeleton wypełnia obszar */
.api-image-placeholder {
  position: absolute;
  inset: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
}
.api-image-placeholder :deep(.b-skeleton) {
  position: absolute;
  inset: 0;
  height: 100%;
  background: #fff;
}
.api-image-placeholder :deep(.b-skeleton-item) {
  height: 100%;
}
</style>
